import styled from 'styled-components'

const Root = styled.div`
  width: 100%;
  padding: 8px 16px 0;
  margin-bottom: 10px;

  display: flex;
  flex-wrap: wrap;
  align-content: space-between;

  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);

  > * {
    margin-bottom: 8px;
  }

  > :not(:last-child) {
    margin-right: 12px;
  }
`

const Spacer = styled.span`
  flex-grow: 1;
`

export default {
  Root,
  Spacer,
}



// WEBPACK FOOTER //
// ./src/pages/report/billing-plan/layout/Toolbar.jsx